import { CountDownService, CountDownTime } from '../../../services/count-down.service';
import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { Vehicle, FuelEnum, TransmissionEnum, ReportStatus } from 'src/app/shared/model/vehicle';
import { Observable } from 'rxjs';
import { DealerService } from 'src/app/shared/services/dealer.service';
import { OpenService } from 'src/app/shared/services/open.service';
import { SessionService } from '@app/store/session/session.service';
import { UserInfo } from '@app/store/session/session.store';

@Component({
  // tslint:disable-next-line: component-selector
  selector: '[app-card-vehicle-fast-quote]',
  templateUrl: './card-vehicle-fast-quote.component.html',
  styleUrls: ['./card-vehicle-fast-quote.component.scss']
})
export class CardVehicleFastQuoteComponent implements OnInit {
  @Input() vehicle: Vehicle;
  @Input() ownsVehicle: boolean;
  contador: CountDownTime;
  imgIndex = 0;
  vehicleImages: string[] = [];

  @Input()
  gridMode?: boolean;

  user: UserInfo;

  constructor(
    private countDownService: CountDownService, private dealerService: DealerService,
    private openService: OpenService,
    private sessionService: SessionService
  ) { }

  ngOnInit() {
    this.sessionService.getUser().subscribe(u => {
      this.user = u;
    });

    this.countDownService.countDownTime(this.vehicle.expirationTimeLeft).subscribe(contador => {
      this.contador = contador;
    });
    if (this.vehicle.imgUrls && this.vehicle.imgUrls.length > 0) {
      this.vehicle.imgUrls = this.vehicle.imgUrls.filter((imgUrl) => {
        return imgUrl.endsWith('png') || imgUrl.endsWith('jpg') || imgUrl.endsWith('jpeg')
      });
      this.vehicleImages.push(this.vehicle.imgUrls[0]);
    }

    if (this.ownsVehicle && this.vehicle.hasBids && this.vehicle.active) {
      this.vehicle.currentPrice -= this.vehicle.bidStep;
    }
  }

  get fuel() {
    return FuelEnum[this.vehicle.fuel];
  }

  get transmission() {
    return TransmissionEnum[this.vehicle.transmission];
  }


  get reportStatus(): string {
    return ReportStatus[this.vehicle.reportStatus];
  }

  get slug(): string {
    return this.openService.getVehicleSlug(this.vehicle);
  }

  get price(): boolean {
    return this.vehicle.ownsAnyBid;
  }

  getSmallImageUrl(imgUrl: string): string {
    if (imgUrl.indexOf('img.autoarremate.com.br') >= 0) {
      const lastDot = imgUrl.lastIndexOf('.');
      return imgUrl.substring(0, lastDot) + '_small' + imgUrl.substring(lastDot);
    } else {
      return imgUrl;
    }
  }

  nextImg(vehicle) {
    if (this.vehicleImages.length <= 1) {
      this.vehicleImages = this.vehicle.imgUrls;
    }
    if (this.imgIndex < (vehicle.imgUrls.length - 1)) {
      this.imgIndex = this.imgIndex + 1;
    }
  }
  prevImg(vehicle) {
    if (this.imgIndex > 0) {
      this.imgIndex = this.imgIndex - 1;
    }
  }

  toggleFavorite(event: Event): boolean {
    this.vehicle.favorite = !this.vehicle.favorite;
    if (this.vehicle.favorite) {
      this.dealerService.saveAsFavorite(this.vehicle.id, true).subscribe();
    } else {
      this.dealerService.removeAsFavorite(this.vehicle.id, true).subscribe();
    }
    event.stopPropagation();
    return false;
  }

}
